"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarAndValidation = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _styles = require("./styles");

var _GeneralButton = require("../../atoms/GeneralButton");

var _ValidationPanel = require("../../atoms/ValidationPanel");

var _RetailerSelector = require("../RetailerSelector");

var _jsxRuntime = require("react/jsx-runtime");

//Components
var AvatarAndValidation = function AvatarAndValidation(_ref) {
  var retailers = _ref.retailers,
      validation = _ref.validation,
      activeRetailer = _ref.activeRetailer,
      setActiveRetailer = _ref.setActiveRetailer,
      showValidationButtons = _ref.showValidationButtons,
      approve = _ref.approve,
      reject = _ref.reject,
      approveAll = _ref.approveAll,
      rejectAll = _ref.rejectAll,
      showApproveRejectAll = _ref.showApproveRejectAll;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showValidationPanel = _useState2[0],
      setShowValidationPanel = _useState2[1];

  var _useState3 = (0, _react.useState)(validation ? validation : "null-button"),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      buttonType = _useState4[0],
      setButtonType = _useState4[1];

  var closeValidationPanel = function closeValidationPanel(e) {
    if (!e.target.closest("#validation-panel") || e.target.closest(".validation-option") && showValidationPanel) {
      document.removeEventListener("click", closeValidationPanel, false);
      setShowValidationPanel(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (showValidationPanel) {
      document.addEventListener("click", closeValidationPanel, false);
    }
  }, [showValidationPanel]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "buttons-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RetailerSelector.RetailerSelector, {
        retailers: retailers,
        activeRetailer: activeRetailer,
        setActiveRetailer: setActiveRetailer
      }), showValidationButtons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "circular-button ".concat(buttonType),
        onClick: function onClick(e) {
          e.stopPropagation();
          setShowValidationPanel(true);
        }
      })]
    }), showValidationPanel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ValidationPanel.ValidationPanel, {
      id: "validation-panel",
      setOptionClicked: setButtonType,
      setShowValidationPanel: setShowValidationPanel,
      approve: approve,
      reject: reject,
      approveAll: approveAll,
      rejectAll: rejectAll,
      showApproveRejectAll: showApproveRejectAll
    })]
  });
};

exports.AvatarAndValidation = AvatarAndValidation;